<template>
  <div v-show="visible">
    <PersonalCollection
      :shippingMethod="shippingMethod"
      :currentlySelectedRadio="currentlySelectedRadio"
      :currency="currency"
      :order="order"
      :totalPriceIncVat="order.totalPriceIncludingVat"
      :country="country"
      :formResource="formResource"
      v-if="
        shippingMethod.shippingMethodResource.type === 'personal_collection'
      "
      @shippingMethodChanged="$emit('shippingMethodChanged', $event)"
      @shippingMethodVisibilityChanged="shippingMethodVisibilityChanged"
      @isEligibleForFreeShipping="$emit('isEligibleForFreeShipping', $event)"
    >
    </PersonalCollection>

    <PackateryPersonalCollection
      :shippingMethod="shippingMethod"
      :currentlySelectedRadio="currentlySelectedRadio"
      :packateryApiKey="packateryApiKey"
      :currency="currency"
      :order="order"
      :totalPriceIncVat="order.totalPriceIncludingVat"
      :country="country"
      :formResource="formResource"
      v-else-if="
        shippingMethod.shippingMethodResource.type === 'packatery' &&
        (shippingMethod.shippingMethodResource.subtype ===
          'packatery_personal_collection' ||
          shippingMethod.shippingMethodResource.subtype ===
            'personal_collection')
      "
      @shippingMethodChanged="$emit('shippingMethodChanged', $event)"
      @shippingMethodVisibilityChanged="shippingMethodVisibilityChanged"
      @isEligibleForFreeShipping="$emit('isEligibleForFreeShipping', $event)"
    >
    </PackateryPersonalCollection>

    <BalikovnaPersonalCollection
      :shippingMethod="shippingMethod"
      :currentlySelectedRadio="currentlySelectedRadio"
      :currency="currency"
      :order="order"
      :totalPriceIncVat="order.totalPriceIncludingVat"
      :country="country"
      :formResource="formResource"
      v-else-if="
        shippingMethod.shippingMethodResource.type === 'balikovna' &&
        shippingMethod.shippingMethodResource.subtype === 'personal_collection'
      "
      @shippingMethodChanged="$emit('shippingMethodChanged', $event)"
      @shippingMethodVisibilityChanged="shippingMethodVisibilityChanged"
      @isEligibleForFreeShipping="$emit('isEligibleForFreeShipping', $event)"
    >
    </BalikovnaPersonalCollection>

    <GlsPersonalCollection
      :shippingMethod="shippingMethod"
      :currentlySelectedRadio="currentlySelectedRadio"
      :currency="currency"
      :order="order"
      :totalPriceIncVat="order.totalPriceIncludingVat"
      :country="country"
      :formResource="formResource"
      v-else-if="
        shippingMethod.shippingMethodResource.type === 'gls' &&
        (shippingMethod.shippingMethodResource.subtype ===
          'gls_personal_collection' ||
          shippingMethod.shippingMethodResource.subtype ===
            'personal_collection')
      "
      @shippingMethodChanged="$emit('shippingMethodChanged', $event)"
      @shippingMethodVisibilityChanged="shippingMethodVisibilityChanged"
      @isEligibleForFreeShipping="$emit('isEligibleForFreeShipping', $event)"
    >
    </GlsPersonalCollection>

    <OtherShipping
      :shippingMethod="shippingMethod"
      :country="country"
      :formResource="formResource"
      :currency="currency"
      :order="order"
      :totalPriceIncVat="order.totalPriceIncludingVat"
      :fullInvoiceOrIsAddress="fullInvoiceOrIsAddress"
      v-else
      @shippingMethodChanged="$emit('shippingMethodChanged', $event)"
      @shippingMethodVisibilityChanged="shippingMethodVisibilityChanged"
      @isEligibleForFreeShipping="$emit('isEligibleForFreeShipping', $event)"
    >
    </OtherShipping>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import PersonalCollection from "@/components/Form/ShippingMethods/Types/PersonalCollection.vue";
import PackateryPersonalCollection from "@/components/Form/ShippingMethods/Types/PackateryPersonalCollection.vue";
import GlsPersonalCollection from "@/components/Form/ShippingMethods/Types/GlsPersonalCollection.vue";
import FormShippingItem from "@/module/FormShippingItem";
import FormResource from "@/module/Form/Resources/FormResource";
import OtherShipping from "@/components/Form/ShippingMethods/Types/OtherShipping.vue";
import TemplateSettings from "@/module/Form/Resources/TemplateSettings";
import {
  isStringOrNull,
  isObjectOrNull,
} from "@/module/ComponentPropsValidations/validations";
import OrderPrices from "@/module/Order/OrderPrices";
import BalikovnaPersonalCollection from "@/components/Form/ShippingMethods/Types/BalikovnaPersonalCollection.vue";

export default Vue.extend({
  name: "ShippingMethod",

  components: {
    BalikovnaPersonalCollection,
    OtherShipping,
    PackateryPersonalCollection,
    PersonalCollection,
    GlsPersonalCollection,
  },

  props: {
    shippingMethod: {
      type: Object as PropType<FormShippingItem>,
      required: true,
    },
    templateSettings: {
      type: Object as PropType<TemplateSettings>,
      required: true,
    },
    currentlySelectedRadio: {
      required: true,
      validator: isObjectOrNull,
    },
    packateryApiKey: {
      required: true,
      validator: isStringOrNull,
    },
    currency: {
      type: String,
      required: true,
    },
    country: {
      required: true,
      validator: isStringOrNull,
    },
    fullInvoiceOrIsAddress: {
      type: Boolean,
      required: true,
    },
    formResource: {
      type: Object as PropType<FormResource>,
      required: true,
    },
    order: {
      type: Object as PropType<OrderPrices>,
      required: true,
    },
  },

  data(): { visible: boolean } {
    return {
      visible: true,
    };
  },

  computed: {
    singleColumn(): string {
      return (
        this.templateSettings.container_settings.shipping.layout.column ??
        "multi"
      );
    },
  },

  methods: {
    shippingMethodVisibilityChanged(value: { visible: boolean }): void {
      this.visible = value.visible;
      this.$emit("shippingMethodVisibilityChanged", {
        shippingMethodId: this.shippingMethod.shippingMethodResource.id,
        visible: value.visible,
      });
    },
  },
});
</script>

<style></style>
